import React from "react";
import "./custom2.css";

//Preventing right-click > save Image (I know they can just do printScreen, but that is in low res)
//document.addEventListener('contextmenu', event => event.preventDefault());

function Custom4() {
    return(
        <a className="customContainer" href="/custom5">
            <div className="liliesBorder">
                <img src="./images/liliesBorder.jpg" className="liliesBorderImage" alt="Decoration" />
            </div>
            <div className="slideContainer" id="slide2">
                <div className="stepContainer">
                    <span className="stepBox"></span>
                    <span className="stepText">
                        How I can affect detail
                    </span>
                    <span className="arrowFloat">
                        <img className="rightArrow" src="./images/misc/arrowright2.gif" alt="cue to click for next slide."></img>
                    </span>
                </div>
            </div>
            <div className="instructions">
                <div className="instructionText">
                    I can help to bring the picture you like into your price range by using wood grain patterns to mimic detail that would otherwise need to be hand cut. The tree on the left was difficult to cut while the trees on the right was more plain.
                </div>
                <img className="instructionImage" src="./images/commission/treeDetailLevel.jpg" alt="Different methods can replace cutting detail work."></img>
            </div>
        </a>
    );
};


export default Custom4